module.exports = __webpack_public_path__ + "src/assets/games/29/767.jpg";